import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import { __, __r } from 'react-i18n';
import { getFinishedOrderInfo } from '../../../utilities/selectors';
import { TextP } from '../../..';

interface Props {
  order: any;
  emailSent: boolean;
  onConfirmClick: any;
  bodyHtml: string | undefined;
}

export function OrderCancelRequestComponent({
  order,
  emailSent,
  onConfirmClick,
  bodyHtml,
}: Props) {
  if (order) {
    const { orderNr } = getFinishedOrderInfo(order);

    return (
      <Wrapper>
        <Title>
          {__('Žiadosť o zrušenie objednávky č.')} {orderNr}{' '}
        </Title>

        {!emailSent ? (
          <StyledLink onClick={onConfirmClick}>
            {' '}
            {__('Potvrdiť zrušenie objednávky')}{' '}
          </StyledLink>
        ) : (
          <>
            {' '}
            {__(
              'Na Vašu emailovu adresu sme Vám poslali link na zrušenie objednávky',
            )}{' '}
          </>
        )}

        {bodyHtml ? (
          <BodyWrapper dangerouslySetInnerHTML={{ __html: bodyHtml }} />
        ) : (
          <></>
        )}
      </Wrapper>
    );
  }

  return <></>;
}

const Wrapper = styled.div`
  text-align: center;
  width: 100%;
  margin: 0 auto;
  padding: ${rem(80)} 0;
  max-width: ${rem(1180)};

  ${({ theme }) => theme.mediab.m810`
    flex-flow: column;
    align-items: center;
    padding: ${rem(32)} 0 ${rem(56)};
  `}
`;

const Title = styled.h2`
  margin: ${rem(32)} 0;
  font-size: ${rem(30)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(38)};
  font-weight: 500;

  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
    text-align: center;
  `}
`;

const SmallText = styled(TextP)`
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  text-align: center;
`;

const OrderNr = styled(SmallText)`
  font-weight: 500;
  font-family: ${({ theme }) => theme.font.primary};
`;

const buttonLikeCss = css`
  display: inline-block;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primary};
  border: none;
  padding: ${rem(18)} ${rem(24)};
  font-weight: 500;
  font-size: ${rem(16)};
  line-height: ${rem(19)};
  height: initial;
  border-radius: ${rem(4)};
  text-decoration: none;

  ${({ theme }) => theme.media(0, 'sm')} {
    padding: ${rem(10)} ${rem(24)};
    margin-bottom: 0;
    width: initial;
    padding: ${rem(14)} ${rem(24)};
  }
`;

const StyledLink = styled.a`
  ${buttonLikeCss};
`;

const BodyWrapper = styled.div`
  color: black;
  margin-top: 25px;

  tr {
    text-align: left;
  }
`;
